import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from 'html-react-parser'

import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { discountTypeObj, subscriptionPlanType, subscriptionPlanTypeObj } from "../../../../utils/Constants";
import { CampaignsDetails } from "../../services/campaigns.services";

const CampaignsView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Campaigns"),
      url: "/admin/campaigns/list/1",
    },
    { title: t("View"), url: "" },
  ];


  useEffect(() => {
    CampaignsDetails(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("View Campaign")}
                </h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Name")}</th>
                          <td className="text-capitalize">
                            {showdefault?.name || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Code")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.code
                              ? showdefault.code
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Subscription Type")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.plan_type
                              ? subscriptionPlanTypeObj[showdefault.plan_type]
                              : "N/A"}
                          </td>
                        </tr>

                        {
                          showdefault.plan_type=='question' || showdefault.plan_type=='both'
                          ?
                            <>
                              <tr>
                                <th>{t("Questons Plan Type ")}</th>
                                <td className="text-capitalize">
                                  {showdefault && showdefault.question_plan_level
                                    ? showdefault.question_plan_level?.join(', ')
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Questions Discount")}</th>
                                <td className="text-capitalize">
                                  {showdefault && showdefault.question_discount_type && showdefault.question_discount
                                    ? `${showdefault.question_discount} ${showdefault.question_discount_type=='percentage' ? '%' : 'Flat'} Off`
                                    : "N/A"}
                                </td>
                              </tr>
                            </>
                          : null
                        }

                        {
                          showdefault.plan_type=='report' || showdefault.plan_type=='both'
                          ?
                            <>
                               <tr>
                                <th>{t("Reports Plan Type ")}</th>
                                <td className="text-capitalize">
                                  {showdefault && showdefault.report_plan_level
                                    ? showdefault.report_plan_level?.join(', ')
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Reports Discount")}</th>
                                <td className="text-capitalize">
                                  {showdefault && showdefault.report_discount_type && showdefault.report_discount
                                    ? `${showdefault.report_discount} ${showdefault.report_discount_type=='percentage' ? '%' : 'Flat'} Off`
                                    : "N/A"}
                                </td>
                              </tr>
                            </>
                          : null
                        }

                        <tr>
                          <th>{t("Description")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.description
                              ? showdefault.description
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                            <th>{t("list_heading_status")}</th>
                            <td>
                            {showdefault && showdefault?.status == true ? toHtml(showStatus(1)) : toHtml(showStatus(0))}
                            </td>
                        </tr>

                        {/* <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="ml-4 back-button mx-0">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/campaigns/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignsView;
